let g_ok = true;
let g_id = "123";
let p_price = 10;
let collections_list = [];
let mode = 0;
let t_scale = 1;
let g_area = 0;
let munit = 1;
let step = 1;
let type = 1;
let m_width = 0;
let m_length = 0;
let p_cnt = 0;
let manual_cut = 0;
let manual_cut_tapelength = 0;
let isJoin = 0; // 0: no join, 1: join
let variant_map = {}; // Variant mapping for width to variant ID

// These will be initialized from product_json in DOMContentLoaded
let clip_id_list = [];
let clip_cnt_list = [];
let clip_title_list = [];
let clip_unit_list = [];
let clip_price_list = [];
let clip_flag = [];

let wide_list = [];
let last_divide_factor = false;

let page_flag = 1; // product page 0 and calculator page 1 

function setWideList() {
  wide_list = [];
  last_divide_factor = false;

  if (typeof product_json !== 'undefined' && Array.isArray(product_json.variants)) {
    product_json.variants.forEach(variant => {
      let width = parseFloat(variant.option1);
      if (!isNaN(width) && !wide_list.includes(width)) {
        wide_list.push(width);
      }
    });
    wide_list.sort((a, b) => b - a);
  } else {
    console.error("product_json.variants is not available");
  }

  if (
    wide_list.length > 0 &&
    wide_list[wide_list.length - 1] > 2 &&
    m_width > wide_list[wide_list.length - 1]
  ) {
    wide_list.push(wide_list[wide_list.length - 1] / 2);
    last_divide_factor = true;
  }
}

function setCollectionLabel() {
  var labelTxt = "";
  var twide_list = [...wide_list];
  twide_list.sort();
  twide_list.forEach((wide, index) => {
    if (index < twide_list.length - 2) {
      labelTxt += wide + "m, ";
    } else if (index < twide_list.length - 1) {
      labelTxt += wide + "m & ";
    } else {
      labelTxt += wide + "m ";
    }
  });
  $("#product-collections").text("Available in " + labelTxt + "wide");
}

function setSelectedUnit(unit) {
  munit = unit;
  $(".unit-btn").removeClass("selected");

  if (munit === 1) {
    t_scale = 1;
    // METRES
    $("#metres-btn").addClass("selected");
    $("#input-row-1").show();
    $("#input-row-2").hide();
  } else if (munit === 2) {
    t_scale = 0.0254;
    // FEET
    $("#feet-btn").addClass("selected");
    $("#input-row-1").hide();
    $("#input-row-2").show();
  } else if (munit === 3) {
    t_scale = 0.01;
    // CENTEMETRES
    $("#centimetres-btn").addClass("selected");
    $("#input-row-1").show();
    $("#input-row-2").hide();
  } else if (munit === 4) {
    // INCHES
    t_scale = 0.0256410256; // More accurate scale factor
    $("#inches-btn").addClass("selected");
    $("#input-row-1").show();
    $("#input-row-2").hide();
  }

  refreshData();

  if (mode == 0) {
    $("#inner").empty();
    addManualCut();
  }
}

function selectType(type_num) {
  type = type_num;
}

// YOUR OWN SIZE CALCULATION
function calculateOwnPrice(area, tapelength, around) {
  g_area = area;

  clip_cnt_list = Array(9).fill(0);
  
  if(Math.ceil(tapelength) > 0){
    if (product_json.recommend_products.product_0.accessories_enable){
      clip_cnt_list[0] = Math.ceil(tapelength / 4); // adhesive tubes
      clip_flag[0] = product_json.recommend_products.product_0.accessories_required ? 1 : 0; 
    }
    if (product_json.recommend_products.product_1.accessories_enable) {
      clip_cnt_list[1] = Math.ceil(tapelength); // Jointing Tape m
      clip_flag[1] = product_json.recommend_products.product_1.accessories_required ? 1 : 0;
    }
  }
  
  if (type === 1) {
    if (product_json.recommend_products.product_2.accessories_enable) {
      clip_cnt_list[2] = Math.ceil(g_area); // Heavy Duty Weed Control Fabric Membrane
      clip_flag[2] = product_json.recommend_products.product_2.accessories_required ? 1 : 0;
    }
    if (product_json.recommend_products.product_3.accessories_enable) {
      clip_cnt_list[3] = Math.ceil(g_area / 20); // "Weed Fabric Fixing Pegs
      clip_flag[3] = product_json.recommend_products.product_3.accessories_required ? 1 : 0;
    }
    if (product_json.recommend_products.product_4.accessories_enable) {
      clip_cnt_list[4] = Math.ceil(g_area / 10); // Galvanised Green Staple Pegs
      clip_flag[4] = product_json.recommend_products.product_4.accessories_required ? 1 : 0;
    }
    if (product_json.recommend_products.product_7.accessories_enable) {
      clip_cnt_list[7] = Math.ceil(g_area); // 10mm Artificial Grass Underlay
      clip_flag[7] = product_json.recommend_products.product_7.accessories_required ? 1 : 0;
    }
    if (product_json.recommend_products.product_8.accessories_enable) {
      clip_cnt_list[8] = Math.ceil(g_area); // 15mm Artificial Grass Underlay
      clip_flag[8] = product_json.recommend_products.product_8.accessories_required ? 1 : 0;
    }
  } else if (type === 2) {
    if (product_json.recommend_products.product_5.accessories_enable) {
      clip_cnt_list[5] = Math.ceil(g_area / 10); // 2-Part PU Adhesive
      clip_flag[5] = product_json.recommend_products.product_5.accessories_required ? 1 : 0;
    }
    if (product_json.recommend_products.product_7.accessories_enable) {
      clip_cnt_list[7] = Math.ceil(g_area); // 10mm Artificial Grass Underlay
      clip_flag[7] = product_json.recommend_products.product_7.accessories_required ? 1 : 0;
    }
    if (product_json.recommend_products.product_8.accessories_enable) {
      clip_cnt_list[8] = Math.ceil(g_area); // 15mm Artificial Grass Underlay
      clip_flag[8] = product_json.recommend_products.product_8.accessories_required ? 1 : 0;
    }
    if (product_json.recommend_products.product_9.accessories_enable) {
      clip_cnt_list[9] = Math.ceil(g_area / 10); //Underlay Adhesive
      clip_flag[9] = product_json.recommend_products.product_9.accessories_required ? 1 : 0;
    }
  } else if (type === 3) {
    if (product_json.recommend_products.product_6.accessories_enable) {
      clip_cnt_list[6] = Math.ceil(g_area / 5); // Galvinised Green 
      clip_flag[6] = product_json.recommend_products.product_6.accessories_required ? 1 : 0;
    }
    if (product_json.recommend_products.product_7.accessories_enable) {
      clip_cnt_list[7] = Math.ceil(g_area); // 10mm Artificial Grass Underlay
      clip_flag[7] = product_json.recommend_products.product_7.accessories_required ? 1 : 0;
    }
    if (product_json.recommend_products.product_8.accessories_enable) {
      clip_cnt_list[8] = Math.ceil(g_area); // 15mm Artificial Grass Underlay
      clip_flag[8] = product_json.recommend_products.product_8.accessories_required ? 1 : 0;
    }
  } else if (type === 4) {
  } else if (type === 0) {    
    if (product_json.recommend_products.product_2.accessories_enable) {
      clip_cnt_list[2] = Math.ceil(g_area); // Heavy Duty Weed Control Fabric Membrane
      clip_flag[2] = product_json.recommend_products.product_2.accessories_required ? 1 : 0;
    }
    if (product_json.recommend_products.product_3.accessories_enable) {
      clip_cnt_list[3] = Math.ceil(g_area / 20); // "Weed Fabric Fixing Pegs
      clip_flag[3] = product_json.recommend_products.product_3.accessories_required ? 1 : 0;
    }
    if (product_json.recommend_products.product_4.accessories_enable) {
      clip_cnt_list[4] = Math.ceil(g_area / 10); // Galvanised Green Staple Pegs
      clip_flag[4] = product_json.recommend_products.product_4.accessories_required ? 1 : 0;
    }
    if (product_json.recommend_products.product_7.accessories_enable) {
      // clip_cnt_list[7] = Math.ceil(g_area / 10); // HP - 2021-07-19
      clip_cnt_list[7] = Math.ceil(g_area); //10mm Artificial Grass Underlay
      clip_flag[7] = product_json.recommend_products.product_7.accessories_required ? 1 : 0;
    }
    if (product_json.recommend_products.product_8.accessories_enable) {
      clip_cnt_list[8] = Math.ceil(g_area); //15mm Artificial Grass Underlay
      clip_flag[8] = product_json.recommend_products.product_8.accessories_required ? 1 : 0;
    }
  }
  showQuote();
}

// YOUR GARDEN SIZE CALCULATION
function calculateGardenPrice(width, length, tapelength) {
  g_area = width * length;

  clip_cnt_list = Array(9).fill(0);
  console.log('isJoin', isJoin);
    
  if(isJoin == 1){
    if (product_json.recommend_products.product_0.accessories_enable){
      clip_cnt_list[0] = Math.ceil(tapelength / 4); // adhesive tubes
      clip_flag[0] = product_json.recommend_products.product_0.accessories_required ? 1 : 0; 
    }
    if (product_json.recommend_products.product_1.accessories_enable) {
      clip_cnt_list[1] = Math.ceil(tapelength); // Jointing Tape m
      clip_flag[1] = product_json.recommend_products.product_1.accessories_required ? 1 : 0;
    }
  }
  if (type === 1) {
    if (product_json.recommend_products.product_2.accessories_enable) {
      clip_cnt_list[2] = Math.ceil(g_area); // Heavy Duty Weed Control Fabric Membrane
      clip_flag[2] = product_json.recommend_products.product_2.accessories_required ? 1 : 0; 
    }
    if (product_json.recommend_products.product_3.accessories_enable) {
      clip_cnt_list[3] = Math.ceil(g_area / 20); // Weed Fabric Fixing Pegs
      clip_flag[3] = product_json.recommend_products.product_3.accessories_required ? 1 : 0; 
    }
    if (product_json.recommend_products.product_4.accessories_enable) {
      clip_cnt_list[4] = Math.ceil(g_area / 10); // Galvanised Green Staple Pegs
      clip_flag[4] = product_json.recommend_products.product_4.accessories_required ? 1 : 0; 
    }
    if (product_json.recommend_products.product_6.accessories_enable) {
      clip_cnt_list[6] = Math.ceil(((m_width + m_length) * 2) / 5); // Galvinised Green Nails
      clip_flag[6] = product_json.recommend_products.product_6.accessories_required ? 1 : 0; 
    }
    if (product_json.recommend_products.product_7.accessories_enable) {
      clip_cnt_list[7] = Math.ceil(g_area); // 10mm Artificial Grass Underlay
      clip_flag[7] = product_json.recommend_products.product_7.accessories_required ? 1 : 0; 
    }
    if (product_json.recommend_products.product_8.accessories_enable) {
      clip_cnt_list[8] = Math.ceil(g_area); // 15mm Artificial Grass Underlay
      clip_flag[8] = product_json.recommend_products.product_8.accessories_required ? 1 : 0; 
    }
  } else if (type === 2) {
    if (product_json.recommend_products.product_5.accessories_enable) {
      clip_cnt_list[5] = Math.ceil(g_area / 10); // 2-Part PU Adhesive
      clip_flag[5] = product_json.recommend_products.product_5.accessories_required ? 1 : 0; 
    }
    if (product_json.recommend_products.product_7.accessories_enable) {
      clip_cnt_list[7] = Math.ceil(g_area); // 10mm Artificial Grass Underlay
      clip_flag[7] = product_json.recommend_products.product_7.accessories_required ? 1 : 0; 
    }
    if (product_json.recommend_products.product_8.accessories_enable) {
      clip_cnt_list[8] = Math.ceil(g_area); // 15mm Artificial Grass Underlay
      clip_flag[8] = product_json.recommend_products.product_8.accessories_required ? 1 : 0; 
    }
    if (product_json.recommend_products.product_9.accessories_enable) {
      clip_cnt_list[9] = Math.ceil(g_area / 10); // Underlay Adhesive
      clip_flag[9] = product_json.recommend_products.product_9.accessories_required ? 1 : 0; 
    }
  } else if (type === 3) {
    if (product_json.recommend_products.product_6.accessories_enable) {
      clip_cnt_list[6] = Math.ceil(((m_width + m_length) * 2) / 5);
      clip_flag[6] = product_json.recommend_products.product_6.accessories_required ? 1 : 0; 
    }    
    if (product_json.recommend_products.product_7.accessories_enable) {
      clip_cnt_list[7] = Math.ceil(g_area); // 10mm Artificial Grass Underlay
      clip_flag[7] = product_json.recommend_products.product_7.accessories_required ? 1 : 0; 
    }
    if (product_json.recommend_products.product_8.accessories_enable) {
      clip_cnt_list[8] = Math.ceil(g_area); // 15mm Artificial Grass Underlay
      clip_flag[8] = product_json.recommend_products.product_8.accessories_required ? 1 : 0; 
    }
  } else if (type === 4) {
  } else if (type === 0) {
    if (product_json.recommend_products.product_2.accessories_enable) {
      clip_cnt_list[2] = Math.ceil(g_area); // Heavy Duty Weed Control Fabric Membrane
      clip_flag[2] = product_json.recommend_products.product_2.accessories_required ? 1 : 0; 
    }
    if (product_json.recommend_products.product_3.accessories_enable) {
      clip_cnt_list[3] = Math.ceil(g_area / 20); // "Weed Fabric Fixing Pegs
      clip_flag[3] = product_json.recommend_products.product_3.accessories_required ? 1 : 0; 
    }
    if (product_json.recommend_products.product_4.accessories_enable) {
      clip_cnt_list[4] = Math.ceil(g_area / 10); // Galvanised Green Staple Pegs
      clip_flag[4] = product_json.recommend_products.product_4.accessories_required ? 1 : 0; 
    }
    
    if (product_json.recommend_products.product_6.accessories_enable) {
      clip_cnt_list[6] = Math.ceil(((m_width + m_length) * 2) / 5); // Galvinised Green Nails
      clip_flag[6] = product_json.recommend_products.product_6.accessories_required ? 1 : 0; 
    }
    
    if (product_json.recommend_products.product_7.accessories_enable) {
      clip_cnt_list[7] = Math.ceil(g_area); // 10mm Artificial Grass Underlay
      clip_flag[7] = product_json.recommend_products.product_7.accessories_required ? 1 : 0; 
    }
    
    if (product_json.recommend_products.product_8.accessories_enable) {
      clip_cnt_list[8] = Math.ceil(g_area); // 15mm Artificial Grass Underlay
      clip_flag[8] = product_json.recommend_products.product_8.accessories_required ? 1 : 0; 
    }
  }

  showQuote();
}

function showQuote() {
  let total_grass_price = g_area * product_json.product_price;
  $("#grass-price").text(product_json.product_price);
  $("#total-area").text(parseFloat(g_area.toFixed(2)));
  $("#cost-of-grass").text(total_grass_price.toFixed(2));

  var clips_total_price = 0;
  var clip_quote_view = $("#clip-quote-view");
  clip_quote_view.empty();



  for (let i = 0; i < clip_id_list.length; i++) {
    if (clip_cnt_list[i] > 0) {
      var rowDiv = $("<div>", { class: "row" }).attr("id", "clip-row-" + i);
      var unitText = clip_unit_list[i];

      // Handle singular/plural for "tub"
      if (unitText === "tubs" && clip_cnt_list[i] === 1) {
        unitText = "tub";
        console.log("clip_cnt_list[i]", clip_cnt_list[i]);
        console.log("clip_flag[i]", clip_flag[i]);
      }
      
      console.log("unitText", unitText);

      var pTag1 = $("<p>").html(
        clip_title_list[i] +
          " (" +
          clip_cnt_list[i] +
          " " +
          unitText +
          ")"
      );
      var pTag2 = $("<p>", { class: "price" }).text(
        "£" + (clip_cnt_list[i] * clip_price_list[i]).toFixed(2)
      );
      var btnTag = $("<button>")
        .attr("id", "rmv-btn-" + i)
        .addClass("rmv-btn")
        .text("")
        .on("click", function () {
          removeClipBtnClick(i);
        });
      var tagDiv = $("<div>", { class: "tag-group" });

      tagDiv.append(pTag1);
      tagDiv.append(pTag2);
      rowDiv.append(tagDiv);

      if (clip_flag[i] === 0) {
        rowDiv.addClass("clip-row-disable");
        btnTag.html(`<svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 24 24" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path fill="none" d="M0 0h24v24H0V0z"></path><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"></path></svg>`);
      } else if (clip_flag[i] == 1) {
        clips_total_price += clip_cnt_list[i] * clip_price_list[i];
        btnTag.html(`<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_1569_2)"><path d="M6 1C3.24 1 1 3.24 1 6C1 8.76 3.24 11 6 11C8.76 11 11 8.76 11 6C11 3.24 8.76 1 6 1ZM6 10C3.79 10 2 8.21 2 6C2 3.79 3.79 2 6 2C8.21 2 10 3.79 10 6C10 8.21 8.21 10 6 10Z" fill="black"/><path d="M6 8.5C7.38071 8.5 8.5 7.38071 8.5 6C8.5 4.61929 7.38071 3.5 6 3.5C4.61929 3.5 3.5 4.61929 3.5 6C3.5 7.38071 4.61929 8.5 6 8.5Z" fill="#4AA44A"/></g><defs><clipPath id="clip0_1569_2"><rect width="12" height="12" fill="white"/></clipPath></defs></svg>`);
      }
      rowDiv.append(btnTag);

      clip_quote_view.append(rowDiv);
    }
  }

  $("#accessory-total-price").text(clips_total_price.toFixed(2));
  $("#final-total-grass").text("£" + total_grass_price.toFixed(2));
  $("#final-total").text(
    "£" + (clips_total_price + total_grass_price).toFixed(2)
  );
}

function removeClipBtnClick(index) {
  if (clip_flag[index] == 0) {
    clip_flag[index] = 1;
  } else if (clip_flag[index] == 1) {
    clip_flag[index] = 0;
  }

  if (clip_flag.every((item) => item === 0)) {
    $("#check-out-btn-1").hide();
  } else {
    $("#check-out-btn-1").show();
  }

  showQuote();
}

function selectMode(m) {
  mode = m;
  if (m == 0) {
    $("#cal-use").removeClass("selected");
    $("#cus-use").addClass("selected");
    $("#calculator-mode").hide();
    $("#custom-cutter").show();
  } else {
    $("#cal-use").addClass("selected");
    $("#cus-use").removeClass("selected");
    $("#calculator-mode").show();
    $("#custom-cutter").hide();
  }

  refreshData();
}

function calculateGrassRolls(width, max) {
  let results = [];

  if (width <= 0) {
    return { cap: width, widecut: [], step: 0, cover: 0 };
  }

  for (let i = 0; i < wide_list.length; i++) {
    if (wide_list[i] <= max) {
      let result = calculateGrassRolls(width - wide_list[i], wide_list[i]);
      results.push({ result: result, wide: wide_list[i] });
    }
  }

  let bestResult = results[0].result;
  let chooseWide = results[0].wide;

  for (let i = 1; i < results.length; i++) {
    if (results[i].result.cap > bestResult.cap) {
      bestResult = results[i].result;
      chooseWide = results[i].wide;
    } else if (results[i].result.cap === bestResult.cap) {
      // Fixed comparison
      if (results[i].result.step < bestResult.step) {
        bestResult = results[i].result;
        chooseWide = results[i].wide;
      }
    }
  }

  bestResult.widecut.unshift(chooseWide);
  bestResult.step++;
  bestResult.cover += chooseWide;

  return bestResult;
}

// Helper function to format numbers for display
function formatNumberDisplay(num) {
  num = parseFloat(num);
  if (Number.isInteger(num)) {
    return num.toString();
  } else {
    return num.toFixed(2);
  }
}

function drawGrassPlan(
  canvasId,
  width,
  length,
  key_box_id = "#key-box",
  key_box_2_id = "#key-box-2",
  canvasWidth = 400,
  canvasHeight = 250
) {
  let canvas = document.getElementById(canvasId);
  let context = canvas.getContext("2d");
  let length_label = length;

  let result = calculateGrassRolls(width, wide_list[0]);

  // Calculate the grass rolls
  let rolls = result.widecut;

  if (rolls.length >= 2) {
    $(key_box_id).show();
  } else {
    $(key_box_id).hide();
  }

  if (rolls.length >= 2) {
    isJoin = 1;
  } else {
    isJoin = 0;
  }

  calculateGardenPrice(result.cover, length, length * rolls.length);

  width = result.cover + rolls.length * 1;

  if (
    rolls[rolls.length - 1] == wide_list[wide_list.length - 1] &&
    last_divide_factor == true
  ) {
    last_divide_factor = true;
  } else {
    last_divide_factor = false;
  }

  if (last_divide_factor) {
    $(key_box_2_id).show();
  } else {
    $(key_box_2_id).hide();
  }

  let scaleX = canvasWidth / width;
  let scaleY = canvasHeight / length;
  const scale = Math.min(scaleX, scaleY); // Use the smaller scale to ensure the entire area fits

  if (scaleY <= scaleX / 2) {
    scaleX = scale * 2;
  } else if (scaleX <= scaleY / 2) {
    scaleY = scale * 2;
  } else {
    scaleX = scale;
    scaleY = scale;
  }

  width *= scaleX;
  length *= scaleY;

  canvas.width = width;
  canvas.height = length;

  // Font size adjustment based on number of rolls and text width
  let baseFontSize = scale * 0.01 * 16 + 10;
  let fontSize = baseFontSize;
  let minFontSize = 8;

  let currentX = 0;
  let dashX;
  let dashY;

  // Draw each roll
  rolls.forEach((roll, index) => {
    context.fillStyle = "#95C11F99";
    context.fillRect(currentX, 0, (roll + 1) * scaleX, length);

    context.fillStyle = "#FFFFFF";
    context.textAlign = "center";
    context.textBaseline = "middle";

    let formattedLength = formatNumberDisplay(length_label);
    let formattedRoll = formatNumberDisplay(roll);
    let text = `${formattedLength}m x ${formattedRoll}m`;
    let textY = length / 2;
    const textX = currentX + ((roll + 1) * scaleX) / 2;

    // Dynamically shrink font size if text is too wide for the roll
    fontSize = baseFontSize;
    context.font = `${fontSize}px Arial`;
    let maxTextWidth = (roll + 1) * scaleX - 8; // 8px padding
    while (context.measureText(text).width > maxTextWidth && fontSize > minFontSize) {
      fontSize--;
      context.font = `${fontSize}px Arial`;
    }

    if (index < rolls.length - 1 || !last_divide_factor) {
      context.fillText(text, textX, textY);
    }

    currentX += (roll + 1) * scaleX;
  });

  currentX = 0;

  rolls.forEach((roll, index) => {
    dashX = currentX + (roll + 1) * scaleX;
    dashY = 0;
    context.strokeStyle = "#000";
    context.lineWidth = 2; // Adjust line width as needed
    while (dashX < width && dashY < length) {
      context.beginPath();
      context.moveTo(dashX, dashY);
      context.lineTo(dashX, dashY + 6);
      context.stroke();
      dashY += 6 + 3;
    }
    currentX += (roll + 1) * scaleX;
  });

  if (last_divide_factor) {
    let roll = rolls[rolls.length - 1];
    let formattedRoll = formatNumberDisplay(roll);
    let halfLength = formatNumberDisplay(length_label / 2);
    dashX = width - (roll + 1) * scaleX;
    dashY = length / 2;
    context.strokeStyle = "#000";
    context.lineWidth = 2; // Adjust line width as needed
    while (dashX < width) {
      context.beginPath();
      context.moveTo(dashX, dashY);
      context.lineTo(dashX + 6, dashY);
      context.stroke();
      dashX += 6 + 3;
    }
    // Also shrink font size for this text if needed
    fontSize = baseFontSize;
    context.font = `${fontSize}px Arial`;
    let textY = length / 4;
    let textX = width - ((roll + 1) / 2) * scaleX;
    let delta = scaleY * 0.011 * 16 * 1.1 + 12;
    let text1 = `${halfLength}m`;
    let text2 = "x";
    let text3 = `${formattedRoll}m`;
    // Shrink font if any line is too wide
    let maxTextWidth = (roll + 1) * scaleX - 8;
    while ((context.measureText(text1).width > maxTextWidth || context.measureText(text2).width > maxTextWidth || context.measureText(text3).width > maxTextWidth) && fontSize > minFontSize) {
      fontSize--;
      context.font = `${fontSize}px Arial`;
    }
    context.fillText(text1, textX, textY - delta);
    context.fillText(text2, textX, textY);
    context.fillText(text3, textX, textY + delta);
    textY = (length * 3) / 4;
    context.fillText(text1, textX, textY - delta);
    context.fillText(text2, textX, textY);
    context.fillText(text3, textX, textY + delta);
  }
}

function addtoCart(with_clips) {
  // Check if user is logged in
  const isLoggedIn = typeof window.Shopify?.customer?.id === "number" && window.Shopify.customer.id > 0;
  
  if (!isLoggedIn) {
    alert("Please log in to add items to cart.");
    window.location.href = "/account/login?return_to=" + encodeURIComponent(window.location.href);
    return;
  }

  let productsToAdd = [];
  let cuts = [];

  console.log('addtoCart called with mode:', mode);
  console.log('variant_map:', variant_map);

  if (mode === 0) {
    // Custom cutter mode (cus-use)
    // Group cuts by variant ID
    let cutsByVariant = {};
    
    $("#custom-cutter #inner .cut-row").each(function() {
      let length;
      if (munit == 2) {
        length = parseFloat(
          parseFloat($(this).find("input").eq(0).val() || 0) * t_scale * 12.0 +
          parseFloat($(this).find("input").eq(1).val() || 0) * t_scale
        );
      } else {
        length = parseFloat($(this).find("input").val() || 0);
        length = (munit === 3 || munit === 4) ? length * t_scale : length;
      }
      let width = parseFloat($(this).find("select").val() || 0);

      console.log('Processing cut - width:', width, 'length:', length);

      // Map width to variant ID
      const variantId = variant_map[width.toString()] || g_id;
      console.log('Mapped width', width, 'to variant ID:', variantId);

      if (!cutsByVariant[variantId]) {
        cutsByVariant[variantId] = [];
      }
      cutsByVariant[variantId].push({ width, length });
    });

    // Add separate cart items per variant
    Object.entries(cutsByVariant).forEach(([variantId, variantCuts]) => {
      const cutDescriptions = variantCuts.map((cut, index) => 
        `Cut ${index + 1} of ${variantCuts.length}: ${formatNumber(cut.length)}m x ${formatNumber(cut.width)}m`
      ).join('\n');

      // Calculate total area for this variant
      const totalAreaForVariant = variantCuts.reduce((sum, cut) => sum + (cut.length * cut.width), 0);
      const quantity = Math.ceil(totalAreaForVariant);

      console.log('Custom cutter variant area calculation:', {
        variantId,
        cuts: variantCuts.length,
        totalArea: totalAreaForVariant.toFixed(2),
        quantity: quantity
      });

      productsToAdd.push({
        id: parseInt(variantId),
        quantity: quantity,
        properties: { 'Cuts': cutDescriptions }
      });

      console.log('Adding product:', {
        id: variantId,
        quantity: quantity,
        totalArea: totalAreaForVariant.toFixed(2),
        cuts: variantCuts.length
      });
    });

  } else {
    // Calculator mode (cal-use)
    // Calculate the actual roll width to be used
    const rollResult = calculateGrassRolls(m_width, wide_list[0]);
    const actualWidth = rollResult.cover;
    const actualLength = m_length;
    const rolls = rollResult.widecut;

    console.log('Calculator mode - rolls:', rolls);

    // Group rolls by variant ID
    let cutsByVariant = {};
    
    rolls.forEach((rollWidth, index) => {
      // Map roll width to variant ID
      const variantId = variant_map[rollWidth.toString()] || g_id;
      console.log('Mapped roll width', rollWidth, 'to variant ID:', variantId);

      if (!cutsByVariant[variantId]) {
        cutsByVariant[variantId] = [];
      }
      cutsByVariant[variantId].push({ width: rollWidth, length: actualLength });
    });

    // Add separate cart items per variant
    Object.entries(cutsByVariant).forEach(([variantId, variantCuts]) => {
      const cutDescriptions = variantCuts.map((cut, index) => 
        `Cut ${index + 1} of ${variantCuts.length}: ${formatNumber(cut.length)}m x ${formatNumber(cut.width)}m`
      ).join('\n');

      // Calculate total area for this variant
      const totalAreaForVariant = variantCuts.reduce((sum, cut) => sum + (cut.length * cut.width), 0);
      const quantity = Math.ceil(totalAreaForVariant);

      console.log('Calculator variant area calculation:', {
        variantId,
        cuts: variantCuts.length,
        totalArea: totalAreaForVariant.toFixed(2),
        quantity: quantity
      });

      productsToAdd.push({
        id: parseInt(variantId),
        quantity: quantity,
        properties: { 'Cuts': cutDescriptions }
      });

      console.log('Adding calculator product:', {
        id: variantId,
        quantity: quantity,
        totalArea: totalAreaForVariant.toFixed(2),
        cuts: variantCuts.length
      });
    });
  }

  // Add accessories if needed
  if (with_clips == true) {
    for (let i = 0; i < clip_id_list.length; i++) {
      if (clip_cnt_list[i] > 0 && clip_flag[i] == 1) {
        productsToAdd.push({
          id: clip_id_list[i],
          quantity: clip_cnt_list[i],
        });
      }
    }
  }

  let formData = {
    items: productsToAdd,
  };

  console.log('Final cart payload:', formData);

  let cartResponse = fetch(window.Shopify.routes.root + "cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  })
    .then((response) => {
      $("input, button, select").prop("disabled", false);
      window.location.href = "/cart";
      return response.json();
    })
    .catch((error) => {
      alert("Products are not added to your cart!");
      console.error("Error:", error);
    });
}

function unitText(flag = 0) {
  if (munit === 1) {
    return ["m"];
  } else if (munit === 2) {
    return ["ft", (flag == 0)?"inches":"in"];
  } else if (munit === 4) {
    return ["in", (flag == 0)?"inches":"in"];
  } else {
    return ["cm"];
  }
}

function addManualCut() {
  var $cutRow = $("<div>")
    .attr("id", "cus-row-" + manual_cut)
    .addClass("cut-row cut-row-" + manual_cut);

  var $lengthInput;

  if (munit === 2) { // Feet and Inches
    $lengthInput = $("<div>").attr({
      id: "cutter-length-group-" + manual_cut,
      class: "cutter-length-group",
    });
    var $feetInput = $("<input>").attr({
      id: "cutter-length-" + manual_cut + "-f",
      name: "cutter-length-" + manual_cut + "-f",
      type: "text",
      value: "",
      class: "form-input",
      placeholder: "Length",
    });
    var $inchInput = $("<input>").attr({
      id: "cutter-length-" + manual_cut + "-i",
      name: "cutter-length-" + manual_cut + "-i",
      type: "text",
      value: "",
      class: "form-input",
      placeholder: "Length",
    });

    $lengthInput.append($feetInput);
    $lengthInput.append($("<p>").html("ft"));
    $lengthInput.append($inchInput);
    $lengthInput.append($("<p>").html("in"));

    let feetPattern = /^\d{0,2}$/;
    let inchPattern = /^\d{0,2}$/;

    $feetInput.data("prev", "");
    $feetInput.on("input", function () {
      let value = $(this).val();
      let $nextInput = $(this).parent().find("input").eq(1); // Corresponding inches field
      let $currentFeetInput = $(this);
      let currentInches = parseInt($nextInput.val() || 0);
      let originalValue = value;

      if (feetPattern.test(value)) {
        $(this).data("prev", value);
        if (value.length === 2) {
          $nextInput.focus();
        }
        let totalInches = parseInt(value || 0) * 12 + currentInches;
        let convertedValue = totalInches * t_scale;
        if (convertedValue > 25) {
          let maxFeet = 81;
          let maxInches = 3;
          $currentFeetInput.val(maxFeet.toString());
          $nextInput.val(maxInches.toString());
          $currentFeetInput.data("prev", maxFeet.toString());
          $nextInput.data("prev", maxInches.toString());
          $("#cus-cut-warning").text("Length must be under 25m (81 feet 3 inches).").show();
        } else {
          if (parseInt(value || 0) >= 81) {
            if (currentInches > 3) {
              $nextInput.val("3");
              $nextInput.data("prev", "3");
              $("#cus-cut-warning").text("Length must be under 25m (81 feet 3 inches).").show();
            } else {
              $("#cus-cut-warning").hide();
            }
          } else {
            $("#cus-cut-warning").hide();
          }
        }
      } else {
        let truncated = value.replace(/\D/g, "").slice(0, 2);
        if (truncated !== originalValue) {
          $(this).val(truncated);
          $(this).data("prev", truncated);
          $("#cus-cut-warning").text("Input restricted due to digit limit").show();
        }
        if (truncated.length === 2) {
          $nextInput.focus();
        }
        let totalInches = parseInt(truncated || 0) * 12 + currentInches;
        let convertedValue = totalInches * t_scale;
        if (convertedValue > 25) {
          let maxFeet = 81;
          let maxInches = 3;
          $currentFeetInput.val(maxFeet.toString());
          $nextInput.val(maxInches.toString());
          $currentFeetInput.data("prev", maxFeet.toString());
          $nextInput.data("prev", maxInches.toString());
          $("#cus-cut-warning").text("Length must be under 25m (81 feet 3 inches).").show();
        } else {
          if (parseInt(truncated || 0) >= 81) {
            if (currentInches > 3) {
              $nextInput.val("3");
              $nextInput.data("prev", "3");
              $("#cus-cut-warning").text("Length must be under 25m (81 feet 3 inches).").show();
            } else {
              $("#cus-cut-warning").hide();
            }
          } else {
            $("#cus-cut-warning").hide();
          }
        }
      }
      calManualCutValue();
    });

    $inchInput.data("prev", "");
    $inchInput.on("input", function () {
      let value = $(this).val();
      let $feetInput = $(this).parent().find("input").eq(0); // Corresponding feet field
      let $currentInchInput = $(this);
      let feetValue = parseInt($feetInput.val() || 0);
      let originalValue = value;

      if (inchPattern.test(value)) {
        $(this).data("prev", value);
        let maxInches = (feetValue >= 81) ? 3 : 11;
        if (parseInt(value || 0) > maxInches) {
          $currentInchInput.val(maxInches.toString());
          $currentInchInput.data("prev", maxInches.toString());
          $("#cus-cut-warning").text("Length must be under 25m (81 feet 3 inches).").show();
        }
        let totalInches = feetValue * 12 + parseInt(value || 0);
        let convertedValue = totalInches * t_scale;
        if (convertedValue > 25) {
          let maxFeet = 81;
          let maxInches = 3;
          $feetInput.val(maxFeet.toString());
          $currentInchInput.val(maxInches.toString());
          $currentInchInput.data("prev", maxInches.toString());
          $feetInput.data("prev", maxFeet.toString());
          $("#cus-cut-warning").text("Length must be under 25m (81 feet 3 inches).").show();
        } else {
          $("#cus-cut-warning").hide();
        }
      } else {
        let truncated = value.replace(/\D/g, "").slice(0, 2);
        if (truncated !== originalValue) {
          $(this).val(truncated);
          $(this).data("prev", truncated);
          $("#cus-cut-warning").text("Input restricted due to digit limit").show();
        }
        let maxInches = (feetValue >= 81) ? 3 : 11;
        if (parseInt(truncated || 0) > maxInches) {
          $currentInchInput.val(maxInches.toString());
          $currentInchInput.data("prev", maxInches.toString());
          $("#cus-cut-warning").text("Length must be under 25m (81 feet 3 inches).").show();
        }
        let totalInches = feetValue * 12 + parseInt(truncated || 0);
        let convertedValue = totalInches * t_scale;
        if (convertedValue > 25) {
          let maxFeet = 81;
          let maxInches = 3;
          $feetInput.val(maxFeet.toString());
          $currentInchInput.val(maxInches.toString());
          $currentInchInput.data("prev", maxInches.toString());
          $feetInput.data("prev", maxFeet.toString());
          $("#cus-cut-warning").text("Length must be under 25m (81 feet 3 inches).").show();
        } else {
          $("#cus-cut-warning").hide();
        }
      }
      calManualCutValue();
    });
  } else {
    $lengthInput = $("<div>").attr({
      id: "cutter-length-group-" + manual_cut,
      class: "cutter-length-group",
    });
    var $lInput = $("<input>").attr({
      id: "cutter-length-" + manual_cut,
      name: "cutter-length-" + manual_cut,
      type: "text",
      value: "",
      class: "form-input",
      placeholder: "Length",
    });

    $lengthInput.append($lInput);

    let pattern;
    if (munit === 1) { // Metres
      pattern = /^(\d{0,2}|\.\d{0,2}|\d{0,2}\.\d{0,2})$/;
    } else if (munit === 3) { // Centimetres
      pattern = /^\d{0,4}$/;
    } else if (munit === 4) { // Inches
      pattern = /^\d{0,3}$/;
    }

    $lInput.data("prev", "");
    $lInput.on("input", function () {
      let value = $(this).val();
      let prevValue = $(this).data("prev") || "";
          
      if (manual_cut === 0) {
        if (munit === 1) { // Metres
          // Always format the input immediately for metres
          let formattedValue = formatDecimalInput(value, 2, 2);
          
          // Check if the formatted value is different from input (indicating truncation)
          if (formattedValue !== value) {
            $(this).val(formattedValue);
            value = formattedValue;
          }
          
          // Validate the formatted value
          let numericValue = (value.split(".")[0] || "").replace(/\D/g, ""); // Digits before decimal
          let length = numericValue.length;

          if (length > 2) {
            // If more than 2 digits before decimal, revert to previous value
            $(this).val($(this).data("prev"));
            $("#cus-cut-warning").text("Length must be under 25m").show();
          } else if (length === 2) {
            let num = parseFloat(value);
            if (!isNaN(num) && num > 25) {
              // If 2 digits and greater than 25, cap at 25
              $(this).val("25");
              $(this).data("prev", "25");
              $("#cus-cut-warning").text("Length must be under 25m").show();
            } else {
              // If 2 digits and less than or equal to 25, update previous value
              $(this).data("prev", value);
              $("#cus-cut-warning").hide();
            }
          } else {
            // If fewer than 2 digits before decimal, update previous value
            $(this).data("prev", value);
            $("#cus-cut-warning").hide();
          }
        } else if (munit === 3) { // Centimetres
          
          // Remove any non-digit characters including decimal points
          let numericValue = value.replace(/[^\d]/g, "");
          
          // If the original value contained a decimal point, revert to previous value
          if (value.includes('.')) {
            $(this).val($(this).data("prev"));
            $("#cus-cut-warning").text("Please enter whole numbers only for centimeters").show();
            return;
          }

          let length = numericValue.length;

          if (length > 4) {
            // If more than 4 digits, revert to previous value
            $(this).val($(this).data("prev"));
            $("#cus-cut-warning").text("Length must be under 25m (2500 cm)").show();
          } else if (length === 4) {
            let num = parseInt(numericValue, 10);
            if (num > 2500) {
              // If 4 digits and greater than 2500, cap at 2500
              $(this).val("2500");
              $(this).data("prev", "2500");
              $("#cus-cut-warning").text("Length must be under 25m (2500 cm)").show();
            } else {
              // If 4 digits and less than or equal to 2500, update previous value
              $(this).data("prev", numericValue);
              $("#cus-cut-warning").hide();
            }
          } else {
            // If fewer than 4 digits, update previous value
            $(this).data("prev", numericValue);
            $("#cus-cut-warning").hide();
          }
        } else if (munit === 4) { // Inches
          // Remove any non-digit characters including decimal points
          let numericValue = value.replace(/[^\d]/g, "");
          
          // If the original value contained a decimal point, revert to previous value
          if (value.includes('.')) {
            $(this).val($(this).data("prev"));
            $("#cus-cut-warning").text("Please enter whole numbers only for inches").show();
            return;
          }

          let length = numericValue.length;

          if (length > 3) {
            // If more than 3 digits, revert to previous value
            $(this).val($(this).data("prev"));
            $("#cus-cut-warning").text("Length must be under 25m (984 inches)").show();
          } else if (length === 3) {
            let num = parseInt(numericValue, 10);
            if (num > 984) {
              // If 3 digits and greater than 984, cap at 984
              $(this).val("984");
              $(this).data("prev", "984");
              $("#cus-cut-warning").text("Length must be under 25m (984 inches)").show();
            } else {
              // If 3 digits and less than or equal to 984, update previous value
              $(this).data("prev", numericValue);
              $("#cus-cut-warning").hide();
            }
          } else {
            // If fewer than 3 digits, update previous value
            $(this).data("prev", numericValue);
            $("#cus-cut-warning").hide();
          }
        }
      } else {        
        if (munit === 1) { // Metres
          let numericValue = (value.split(".")[0] || "").replace(/\D/g, ""); // Digits before decimal
          let length = numericValue.length;

          if (length > 2) {
            // If more than 2 digits before decimal, revert to previous value
            $(this).val($(this).data("prev"));
            $("#cus-cut-warning").text("Length must be under 25m").show();
          } else if (length === 2) {
            let num = parseFloat(value);
            if (!isNaN(num) && num > 25) {
              // If 2 digits and greater than 25, cap at 25
              $(this).val("25");
              $(this).data("prev", "25");
              $("#cus-cut-warning").text("Length must be under 25m").show();
            } else {
              // If 2 digits and less than or equal to 25, update previous value
              $(this).data("prev", value);
              if (pattern.test(value)) {
                $("#cus-cut-warning").hide();
              } else {
                $("#cus-cut-warning").text("Input restricted due to digit limit.").show();
              }
            }
          } else {
            // If fewer than 2 digits before decimal, update previous value
            $(this).data("prev", value);
            if (pattern.test(value)) {
              $("#cus-cut-warning").hide();
            } else {
              $("#cus-cut-warning").text("Input restricted due to digit limit.").show();
            }
          }
        } else if (munit === 3) { // Centimetres
          
          // Remove any non-digit characters including decimal points
          let numericValue = value.replace(/[^\d]/g, "");
          
          // If the original value contained a decimal point, revert to previous value
          if (value.includes('.')) {
            $(this).val($(this).data("prev"));
            $("#cus-cut-warning").text("Please enter whole numbers only for centimeters").show();
            return;
          }

          let length = numericValue.length;

          if (length > 4) {
            // If more than 4 digits, revert to previous value
            $(this).val($(this).data("prev"));
            $("#cus-cut-warning").text("Length must be under 25m (2500 cm)").show();
          } else if (length === 4) {
            let num = parseInt(numericValue, 10);
            if (num > 2500) {
              // If 4 digits and greater than 2500, cap at 2500
              $(this).val("2500");
              $(this).data("prev", "2500");
              $("#cus-cut-warning").text("Length must be under 25m (2500 cm)").show();
            } else {
              // If 4 digits and less than or equal to 2500, update previous value
              $(this).data("prev", numericValue);
              $("#cus-cut-warning").hide();
            }
          } else {
            // If fewer than 4 digits, update previous value
            $(this).data("prev", numericValue);
            $("#cus-cut-warning").hide();
          }
        } else if (munit === 4) { // Inches

          // Remove any non-digit characters including decimal points
          let numericValue = value.replace(/[^\d]/g, "");
          
          // If the original value contained a decimal point, revert to previous value
          if (value.includes('.')) {
            $(this).val($(this).data("prev"));
            $("#cus-cut-warning").text("Please enter whole numbers only for inches").show();
            return;
          }

          let length = numericValue.length;

          if (length > 3) {
            // If more than 3 digits, revert to previous value
            $(this).val($(this).data("prev"));
            $("#cus-cut-warning").text("Length must be under 25m (984 inches)").show();
          } else if (length === 3) {
            let num = parseInt(numericValue, 10);
            if (num > 984) {
              // If 3 digits and greater than 984, cap at 984
              $(this).val("984");
              $(this).data("prev", "984");
              $("#cus-cut-warning").text("Length must be under 25m (984 inches)").show();
            } else {
              // If 3 digits and less than or equal to 984, update previous value
              $(this).data("prev", numericValue);
              $("#cus-cut-warning").hide();
            }
          } else {
            // If fewer than 3 digits, update previous value
            $(this).data("prev", numericValue);
            $("#cus-cut-warning").hide();
          }
        }
      }
      calManualCutValue();
    });
  }

  var $btnTag = $("<button>")
    .attr("id", "cus-rmv-btn-" + manual_cut)
    .addClass("rmv-btn")
    .text("x")
    .on("click", function () {
      $cutRow.remove();
      calManualCutValue();
      manual_cut--;
    });

  var $widthSelect = $("<select>")
    .attr({
      id: "SingleOptionSelector-" + manual_cut,
      "data-single-option-selector": "",
      "data-index": "option1",
    })
    .addClass("single-option-selector width_select form-select")
    .on("input", function () {
      calManualCutValue();
    });

  // Use product_json.variants for width options
  if (typeof product_json !== 'undefined' && Array.isArray(product_json.variants)) {
    product_json.variants.forEach(variant => {
      let width = parseFloat(variant.option1);
      if (!isNaN(width)) {
        let label = `${width}m`;


        if (munit === 2) {
          const feet = Math.floor(width / t_scale / 12);
          const inches = Math.round(width / t_scale - feet * 12);
          const unitTextParts = unitText(page_flag);
          label = `${feet}${unitTextParts[0]} ${inches}${unitTextParts[1]} (${width}m)`;
        } else if (munit === 3) {
          label = `${Math.ceil(width / t_scale)}${unitText(page_flag)[0]} (${width}m)`;
        } else if (munit === 4) {
          label = `${Math.round(width / t_scale)}${unitText(page_flag)[0]} (${width}m)`;
        } else {
          label = `${Math.ceil(width / t_scale)}${unitText(page_flag)[0]}`;
        }
  
        // console.log("label", label);

        $widthSelect.append($('<option>').attr('value', width).text(label));
      }
    });
  } else {
    // fallback to wide_list if product_json is not available
    var twide_list = [...wide_list];
    twide_list.sort();
    twide_list.forEach((wide) => {
      let label = `${wide}m`;


      if (munit === 2) {
        const feet = Math.floor(wide / t_scale / 12);
        const inches = Math.round(wide / t_scale - feet * 12);
        const unitTextParts = unitText(page_flag);
        label = `${feet}${unitTextParts[0]} ${inches}${unitTextParts[1]} (${wide}m)`;
      } else if (munit === 3) {
        label = `${Math.ceil(wide / t_scale)}${unitText(page_flag)[0]} (${wide}m)`;
      } else if (munit === 4) {
        label = `${Math.round(wide / t_scale)}${unitText(page_flag)[0]} (${wide}m)`;
      } else {
        label = `${Math.ceil(wide / t_scale)}${unitText(page_flag)[0]}`;
      }

      // console.log("label", label);


      $widthSelect.append($('<option>').attr('value', wide).text(label));
    });
  }

  $widthSelect.val($widthSelect.find("option:first").val());

  $cutRow.append($lengthInput);
  $cutRow.append($widthSelect);
  $cutRow.append($btnTag);

  $("#inner").append($cutRow);

  manual_cut++;

  calManualCutValue();
}

function calManualCutValue() {
  g_area = 0;
  manual_cut_tapelength = 0;
  let first_length = 0;
  let total_width = 0;  // Track total width
  let total_length = 0; // Track the maximum length (assuming cuts are placed side by side)

  $("#custom-cutter #inner .cut-row").each(function (index) {
    var length;

    if (index === 0) {
      if (munit == 2) {
        first_length = parseFloat(
          parseFloat($(this).find("input").eq(0).val() || 0) * t_scale * 12.0 +
            parseFloat($(this).find("input").eq(1).val() || 0) * t_scale
        );
      } else {
        first_length = parseFloat($(this).find("input").val() || 0);
        // Convert first_length to meters for consistency
        first_length = (munit === 3 || munit === 4) ? first_length * t_scale : first_length;
      }
    }

    if (munit == 2) {
      length = parseFloat(
        parseFloat($(this).find("input").eq(0).val() || 0) * t_scale * 12.0 +
          parseFloat($(this).find("input").eq(1).val() || 0) * t_scale
      );
    } else {
      length = parseFloat($(this).find("input").val() || 0);
      // Convert length to meters if in centimeters or inches
      length = (munit === 3 || munit === 4) ? length * t_scale : length;
    }

    var width = parseFloat($(this).find("select").val() || 0);

    g_area += length * width;
    manual_cut_tapelength += length;

    // Update total dimensions
    total_width += width; // Add width of each cut (assuming cuts are placed side by side)
    total_length = Math.max(total_length, length); // Use the longest length
  });

  manual_cut_tapelength = parseFloat(manual_cut_tapelength) - first_length;

  // Return total dimensions for display
  return { total_width, total_length };
}

$("#get-quote-btn").click(function () {
  // console.log("get-quote-btn clicked");
  // Check if user is logged in
  const isLoggedIn = typeof window.Shopify?.customer?.id === "number" && window.Shopify.customer.id > 0;
  
  if (!isLoggedIn) {
    alert("Please log in to get your quote.");
    window.location.href = "/account/login?return_to=" + encodeURIComponent(window.location.href);
    return;
  }

  // console.log("isLoggedIn", isLoggedIn);

  if (wide_list.length == 0) {
    $('#wide-sel-warning').show();
    return;
  } else {
    $('#wide-sel-warning').hide();
  }
  if (mode == 1) {
    if (munit == 2) {
      // Parse feet and inches as integers, defaulting to 0 if empty
      const widthFeet = parseInt($("#lawn-width-2-f").val() || "0", 10);
      const widthInches = parseInt($("#lawn-width-2-i").val() || "0", 10);
      const lengthFeet = parseInt($("#lawn-length-2-f").val() || "0", 10);
      const lengthInches = parseInt($("#lawn-length-2-i").val() || "0", 10);
      m_width = widthFeet * 0.3048 + widthInches * 0.0254;
      m_length = lengthFeet * 0.3048 + lengthInches * 0.0254;
    } else {
      m_width = parseFloat($("#lawn-width").val()) * t_scale;
      m_length = parseFloat($("#lawn-length").val()) * t_scale;
    }

    if (m_length > 25) {
      m_length = 25;
    }

    if (m_width >= 1 && m_length >= 1 && m_length <= 25) {
      if (m_width * m_length == 0) {
        return;
      }
      $("#step-1-warning").hide();
      // Calculate the actual roll width to be used
      const rollResult = calculateGrassRolls(m_width, wide_list[0]);
      const actualWidth = rollResult.cover;
      const actualLength = m_length;

      // Use actualWidth for everything
      $("#quote-title").html(
        "Your measurements (" + formatNumberDisplay(actualLength) + "m × " + formatNumberDisplay(actualWidth) + "m)"
      );

      $("#quote-section, #quote-box").show();
      drawGrassPlan(
        "grassCanvas",
        actualWidth,
        actualLength,
        "#key-box",
        "#key-box-2",
        $(".result-box").first().width() - 60,
        $(".result-box").first().height() - 60
      );

      // Use actualWidth for price calculation
      calculateGardenPrice(actualWidth, actualLength, actualLength);
    } else {
      $("#step-1-warning").show();
      $("#quote-box").hide();
    }
  } else {
    const { total_width, total_length } = calManualCutValue();
    calculateOwnPrice(g_area, manual_cut_tapelength, manual_cut_tapelength);
    if (g_area == 0) {
      return;
    }
    $("#quote-title").html(
      "Your measurements (" + formatNumberDisplay(total_length) + "m × " + formatNumberDisplay(total_width) + "m)"
    );
    $("#quote-box").show();
    document.getElementById("quote-box").scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  }
});



function addtoCartManualCut() {
  // Check if user is logged in
  const isLoggedIn = typeof window.Shopify?.customer?.id === "number" && window.Shopify.customer.id > 0;
  
  if (!isLoggedIn) {
    alert("Please log in to add items to cart.");
    window.location.href = "/account/login?return_to=" + encodeURIComponent(window.location.href);
    return;
  }

  console.log('addtoCartManualCut called');
  console.log('variant_map:', variant_map);

  // Group cuts by variant ID
  let cutsByVariant = {};

  $("#custom-cutter #inner .cut-row").each(function () {
    let length;
    if (munit == 2) {
      length = parseFloat(
        parseFloat($(this).find("input").eq(0).val() || 0) * t_scale * 12.0 +
        parseFloat($(this).find("input").eq(1).val() || 0) * t_scale
      );
    } else {
      length = parseFloat($(this).find("input").val() || 0);
      length = (munit === 3 || munit === 4) ? length * t_scale : length;
    }
    let width = parseFloat($(this).find("select").val() || 0);

    console.log('Processing manual cut - width:', width, 'length:', length);

    // Map width to variant ID using variant_map
    const variantId = variant_map[width.toString()] || g_id;
    console.log('Mapped width', width, 'to variant ID:', variantId);

    if (!cutsByVariant[variantId]) {
      cutsByVariant[variantId] = [];
    }
    cutsByVariant[variantId].push({ width, length });
  });

  // Build productsToAdd array: one item per variant, using the correct variant for each width group
  let productsToAdd = [];

  Object.entries(cutsByVariant).forEach(([variantId, variantCuts]) => {
    const cutDescriptions = variantCuts.map((cut, index) => 
      `Cut ${index + 1} of ${variantCuts.length}: ${formatNumber(cut.length)}m x ${formatNumber(cut.width)}m`
    ).join('\n');

    // Calculate total area for this variant
    const totalAreaForVariant = variantCuts.reduce((sum, cut) => sum + (cut.length * cut.width), 0);
    const quantity = Math.ceil(totalAreaForVariant);

    console.log('Variant area calculation:', {
      variantId,
      cuts: variantCuts.length,
      totalArea: totalAreaForVariant.toFixed(2),
      quantity: quantity
    });

    productsToAdd.push({
      id: parseInt(variantId),
      quantity: quantity,
      properties: { 'Cuts': cutDescriptions }
    });

    console.log('Adding manual cut product:', {
      id: variantId,
      quantity: quantity,
      totalArea: totalAreaForVariant.toFixed(2),
      cuts: variantCuts.length
    });
  });

  // Add accessories as separate items if needed (like addtoCart)
  for (let i = 0; i < clip_id_list.length; i++) {
    if (clip_cnt_list[i] > 0 && clip_flag[i] == 1) {
      productsToAdd.push({
        id: clip_id_list[i],
        quantity: clip_cnt_list[i],
      });
    }
  }

  let formData = {
    items: productsToAdd,
  };

  console.log('Final manual cut cart payload:', formData);

  let cartResponse = fetch(window.Shopify.routes.root + "cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  })
    .then((response) => {
      window.location.href = "/cart";
      return response.json();
    })
    .catch((error) => {
      alert("Products are not added on your cart!");
      console.error("Error:", error);
    });
}

function refreshData() {
  g_area = 0;
  m_width = 0;
  m_length = 0;
  manual_cut = 0;
  manual_cut_tapelength = 0;
  clip_flag.fill(0);

  // Load variant map from global window object
  if (typeof window.variantMap !== 'undefined') {
    variant_map = window.variantMap;
    console.log('Loaded variant_map:', variant_map);
  } else {
    console.warn('variantMap not found in window object');
  }

  $("#lawn-width").val("");
  $("#lawn-length").val("");
  $(
    "#quote-section, #quote-box, #quote-warning, #step-1-warning, #cus-cut-warning"
  ).hide();
  $("#checkout-warning-msg").hide();
  $("input, button, select").prop("disabled", false);
}

$("input").on("wheel", function (e) {
  e.preventDefault();
});


$("#lawn-length").on("input", function () {
  let value = $(this).val();
  let pattern;

  if (munit === 1) { // Metres
    pattern = /^\d{0,2}(\.\d{0,2})?$/;
  } else if (munit === 3) { // Centimetres
    pattern = /^\d{0,4}$/;
  } else if (munit === 4) { // Inches
    pattern = /^\d{0,3}$/;
  }

  if (munit !== 2) { // Skip Feet and Inches (handled separately)
    let originalValue = value;

    if (munit === 1) { // Metres
      // Always format the input immediately for metres
      let formattedValue = formatDecimalInput(value, 2, 2);
      
      // Check if the formatted value is different from input (indicating truncation)
      if (formattedValue !== value) {
        $(this).val(formattedValue);
        value = formattedValue;
      }
      
      let numericValue = (value.split(".")[0] || "").replace(/\D/g, ""); // Digits before decimal
      let length = numericValue.length;

      if (length > 2) {
        // If more than 2 digits before decimal, revert to previous value
        $(this).val($(this).data("prev"));
        $("#step-1-warning").text("Length must be under 25m").show();
      } else if (length === 2) {
        let num = parseFloat(value);
        if (!isNaN(num) && num > 25) {
          // If 2 digits and greater than 25, cap at 25
          $(this).val("25");
          $(this).data("prev", "25");
          $("#step-1-warning").text("Length must be under 25m").show();
        } else {
          // If 2 digits and less than or equal to 25, update previous value
          $(this).data("prev", value);
          $("#step-1-warning").hide();
        }
      } else {
        // If fewer than 2 digits before decimal, update previous value
        $(this).data("prev", value);
        $("#step-1-warning").hide();
      }
    } else if (munit === 3) { // Centimetres
      let numericValue = value.replace(/\D/g, "");
      let length = numericValue.length;

      if (length > 4) {
        // If more than 4 digits, revert to previous value
        $(this).val($(this).data("prev"));
        $("#step-1-warning").text("Length must be under 25m").show();
      } else if (length === 4) {
        let num = parseInt(numericValue, 10);
        if (num > 2500) {
          // If 4 digits and greater than 2500, cap at 2500
          $(this).val("2500");
          $(this).data("prev", "2500");
          $("#step-1-warning").text("Length must be under 25m").show();
        } else {
          // If 4 digits and less than or equal to 2500, update previous value
          $(this).data("prev", numericValue);
          $("#step-1-warning").hide();
        }
      } else {
        // If fewer than 4 digits, update previous value
        $(this).data("prev", numericValue);
        $("#step-1-warning").hide();
      }
    } else if (munit === 4) { // Inches (previous logic)
      let numericValue = value.replace(/\D/g, "");
      let length = numericValue.length;

      if (length > 3) {
        $(this).val($(this).data("prev"));
        $("#step-1-warning").text("Length must be under 25m (984 inches)").show();
      } else if (length === 3) {
        let num = parseInt(numericValue, 10);
        if (num > 984) {
          $(this).val("984");
          $(this).data("prev", "984");
          $("#step-1-warning").text("Length must be under 25m (984 inches)").show();
        } else {
          $(this).data("prev", numericValue);
          $("#step-1-warning").hide();
        }
      } else {
        $(this).data("prev", numericValue);
        $("#step-1-warning").hide();
      }
    }
  }
});


$("#lawn-width").on("input", function () {
  let value = $(this).val();
  let pattern;

  if (munit === 1) { // Metres
    pattern = /^\d{0,2}(\.\d{0,2})?$/;
  } else if (munit === 3) { // Centimetres
    pattern = /^\d{0,4}$/;
  } else if (munit === 4) { // Inches
    pattern = /^\d{0,3}$/;
  }

  if (munit !== 2) { // Skip Feet and Inches for now (handled separately)
    let originalValue = value;

    // Special handling for munit === 4 (Inches) to match cus-use behavior
    if (munit === 4) {
      let numericValue = value.replace(/\D/g, ""); // Remove non-numeric characters
      let length = numericValue.length;

      if (length > 3) {
        // If more than 3 digits, revert to previous value and show warning
        $(this).val($(this).data("prev"));
        $("#step-1-warning").text("Width needs to be less than 25m (984 inches).").show();
      } else if (length === 3) {
        let num = parseInt(numericValue, 10);
        if (num > 984) {
          // If 3 digits and greater than 984, cap at 984
          $(this).val("984");
          $(this).data("prev", "984");
          $("#step-1-warning").text("Width needs to be less than 25m (984 inches).").show();
        } else {
          // If 3 digits and less than or equal to 984, update previous value
          $(this).data("prev", numericValue);
          $("#step-1-warning").hide();
        }
      } else {
        // If fewer than 3 digits, update previous value
        $(this).data("prev", numericValue);
        $("#step-1-warning").hide();
      }
    } else if (munit === 1) { // Metres
      // Always format the input immediately for metres
      let formattedValue = formatDecimalInput(value, 2, 2);
      
      // Check if the formatted value is different from input (indicating truncation)
      if (formattedValue !== value) {
        $(this).val(formattedValue);
        value = formattedValue;
      }
      
      // Validate the formatted value
      let numericValue = (value.split(".")[0] || "").replace(/\D/g, ""); // Digits before decimal
      let length = numericValue.length;

      if (length > 2) {
        // If more than 2 digits before decimal, revert to previous value
        $(this).val($(this).data("prev"));
        $("#step-1-warning").text("Length must be under 25m").show();
      } else if (length === 2) {
        let num = parseFloat(value);
        if (!isNaN(num) && num > 25) {
          // If 2 digits and greater than 25, cap at 25
          $(this).val("25");
          $(this).data("prev", "25");
          $("#step-1-warning").text("Length must be under 25m").show();
        } else {
          // If 2 digits and less than or equal to 25, update previous value
          $(this).data("prev", value);
          $("#step-1-warning").hide();
        }
      } else {
        // If fewer than 2 digits before decimal, update previous value
        $(this).data("prev", value);
        $("#step-1-warning").hide();
      }
    } else {
      // Existing logic for other units (Centimeters)
      if (pattern.test(value)) {
        $(this).data("prev", value);
        $("#step-1-warning").hide(); // Ensure warning is hidden for valid input
      } else {
        let truncated;
        if (munit === 3) { // Centimetres
          truncated = value.replace(/\D/g, "").slice(0, 4);
        }
        if (truncated !== originalValue) {
          $(this).val(truncated);
          $(this).data("prev", truncated);
          $("#step-1-warning").text("Input restricted due to digit limit.").show();
        } else {
          $("#step-1-warning").hide();
        }
      }
    }
  }
});

$("#lawn-width-2-f").on("input", function () {
  let value = $(this).val();
  let pattern = /^\d{0,2}$/; // Restrict to 2 digits
  let $nextInput = $(this).parent().find("input").eq(1); // Corresponding inches field

  if (pattern.test(value)) {
    $(this).data("prev", value);
    if (value.length === 2) {
      $nextInput.focus();
    }
    // No 25-meter cap for width
  } else {
    let truncated = value.replace(/\D/g, "").slice(0, 2); // Enforce 2-digit limit
    $(this).val(truncated);
    $(this).data("prev", truncated);
    if (truncated.length === 2) {
      $nextInput.focus();
    }
    // No 25-meter cap for width
  }
});

$("#lawn-length-2-f").on("input", function () {
  let value = $(this).val();
  let pattern = /^\d{0,2}$/; // Restrict to 2 digits
  let $nextInput = $(this).parent().find("input").eq(1); // Corresponding inches field

  if (pattern.test(value)) {
    $(this).data("prev", value);
    if (value.length === 2) {
      $nextInput.focus();
    }
    // Calculate total inches for the current dimension
    let totalInches = parseInt(value) * 12 + parseInt($nextInput.val() || 0);
    let convertedValue = totalInches * t_scale;
    let maxTotalInches = 984; // 81 feet 3 inches ≈ 24.77 meters

    if (convertedValue > 25) { // Cap at 25 meters
      let maxFeet = 81;
      let maxInches = 3;
      $(this).val(maxFeet.toString());
      $nextInput.val(maxInches.toString());
      $(this).data("prev", $(this).val());
      $nextInput.data("prev", $nextInput.val());
      $("#step-1-warning").text("Maximum dimension is 25 meters (81 feet 3 inches) per side.").show();
    } else {
      $("#step-1-warning").hide();
    }
  } else {
    let truncated = value.replace(/\D/g, "").slice(0, 2); // Enforce 2-digit limit
    $(this).val(truncated);
    $(this).data("prev", truncated);
    if (truncated.length === 2) {
      $nextInput.focus();
    }
    // Recalculate total inches after truncation
    let totalInches = parseInt(truncated) * 12 + parseInt($nextInput.val() || 0);
    let convertedValue = totalInches * t_scale;
    let maxTotalInches = 984; // 81 feet 3 inches ≈ 24.77 meters

    if (convertedValue > 25) { // Cap at 25 meters after digit check
      let maxFeet = 81;
      let maxInches = 3;
      $(this).val(maxFeet.toString());
      $nextInput.val(maxInches.toString());
      $(this).data("prev", $(this).val());
      $nextInput.data("prev", $nextInput.val());
      $("#step-1-warning").text("Maximum dimension is 25 meters (81 feet 3 inches) per side.").show();
    } else {
      $("#step-1-warning").hide();
    }
  }
});

$("#lawn-length-2-i").on("input", function () {
  let value = $(this).val();
  let pattern = /^\d{0,2}$/; // Restrict to 2 digits
  let $feetInput = $(this).parent().find("input").eq(0); // Corresponding feet field

  if (pattern.test(value)) {
    $(this).data("prev", value);
    // Enforce max inches of 11
    let inchesValue = parseInt(value);
    if (inchesValue > 11) {
      $(this).val("11");
      $(this).data("prev", "11");
    } else {
      $(this).val(inchesValue.toString()); // Ensure the exact value is set
    }
    // Calculate total inches for the current dimension
    let totalInches = parseInt($feetInput.val() || 0) * 12 + parseInt($(this).val() || 0);
    let convertedValue = totalInches * t_scale;
    let maxTotalInches = 984; // 81 feet 3 inches ≈ 24.77 meters

    if (convertedValue > 25) { // Cap at 25 meters after digit and 12-inch check
      let maxFeet = 81;
      let maxInches = 3;
      $feetInput.val(maxFeet.toString());
      $(this).val(maxInches.toString());
      $(this).data("prev", $(this).val());
      $feetInput.data("prev", $feetInput.val());
      $("#step-1-warning").text("Maximum dimension is 25 meters (81 feet 3 inches) per side.").show();
    } else {
      $("#step-1-warning").hide();
    }
  } else {
    let truncated = value.replace(/\D/g, "").slice(0, 2); // Enforce 2-digit limit
    $(this).val(truncated);
    $(this).data("prev", truncated);
    // Enforce max inches of 11 after truncation
    let inchesValue = parseInt(truncated);
    if (inchesValue > 11) {
      $(this).val("11");
      $(this).data("prev", "11");
    } else {
      $(this).val(inchesValue.toString()); // Ensure the exact value is set
    }
    // Recalculate total inches after truncation
    let totalInches = parseInt($feetInput.val() || 0) * 12 + parseInt($(this).val() || 0);
    let convertedValue = totalInches * t_scale;
    let maxTotalInches = 984; // 81 feet 3 inches ≈ 24.77 meters

    if (convertedValue > 25) { // Cap at 25 meters after digit and 12-inch check
      let maxFeet = 81;
      let maxInches = 3;
      $feetInput.val(maxFeet.toString());
      $(this).val(maxInches.toString());
      $(this).data("prev", $(this).val());
      $feetInput.data("prev", $feetInput.val());
      $("#step-1-warning").text("Maximum dimension is 25 meters (81 feet 3 inches) per side.").show();
    } else {
      $("#step-1-warning").hide();
    }
  }
});

$("#lawn-width-2-i").on("input", function () {
  let value = $(this).val();
  let pattern = /^\d{0,2}$/; // Restrict to 2 digits
  let $feetInput = $(this).parent().find("input").eq(0); // Corresponding feet field

  if (pattern.test(value)) {
    $(this).data("prev", value);
    // Enforce max inches of 11
    let inchesValue = parseInt(value);
    if (inchesValue > 11) {
      $(this).val("11");
      $(this).data("prev", "11");
    } else {
      $(this).val(inchesValue.toString()); // Ensure the exact value is set
    }
    // No 25-meter cap for width
  } else {
    let truncated = value.replace(/\D/g, "").slice(0, 2); // Enforce 2-digit limit
    $(this).val(truncated);
    $(this).data("prev", truncated);
    // Enforce max inches of 11 after truncation
    let inchesValue = parseInt(truncated);
    if (inchesValue > 11) {
      $(this).val("11");
      $(this).data("prev", "11");
    } else {
      $(this).val(inchesValue.toString()); // Ensure the exact value is set
    }
    // No 25-meter cap for width
  }
});

$("select[name='unit-type']").on("change", function () {
  console.log("unit-type", $(this).val());
  if ($(this).val() == "metres") {
    setSelectedUnit(1);
  } else if ($(this).val() == "feet") {
    setSelectedUnit(2);
  } else if ($(this).val() == "centimetres") {
    setSelectedUnit(3);
  } else if ($(this).val() == "inches") {
    setSelectedUnit(4);
  }
});

$("#check-out-btn-1").click(function () {
  if (g_ok) {
    $("input, button, select").prop("disabled", true);
    addtoCart(true);
  } else {
    $("#checkout-warning-msg").show();
  }
});

$("#check-out-btn-0").click(function () {
  if (g_ok) {
    $("input, button, select").prop("disabled", true);
    addtoCart(false);
  } else {
    $("#checkout-warning-msg").show();
  }
});


$("select[name='grass-sub-base']").change(function () {
  console.log("grass-sub-base", $(this).val());
  if ($(this).val() == "regular-grass") {
    selectType(1);
  } else if ($(this).val() == "flags") {
    selectType(2);
  } else if ($(this).val() == "decking") {
    selectType(3);
  } else if ($(this).val() == "none") {
    selectType(0);
  }
  
  // Removed automatic quote trigger - user must click "Get my quote" button
});


$("#cutter-add").click(function (event) {
  addManualCut();
});

$("#cal-use").click(function () {
  selectMode(1);
});

$("#cus-use").click(function () {
  $("#inner").empty();
  addManualCut();
  selectMode(0);
});

$("#lawn-length-2-f").on("input", function () {
  let value = $(this).val();
  let pattern = /^\d{0,2}$/; // Restrict to 2 digits
  let $nextInput = $(this).parent().find("input").eq(1); // Corresponding inches field

  if (pattern.test(value)) {
    $(this).data("prev", value);
    if (value.length === 2) {
      $nextInput.focus();
    }
    // Calculate total inches for the current dimension
    let totalInches = parseInt(value) * 12 + parseInt($nextInput.val() || 0);
    let convertedValue = totalInches * t_scale;
    let maxTotalInches = 984; // 81 feet 3 inches ≈ 24.77 meters

    if (convertedValue > 25) { // Cap at 25 meters
      let maxFeet = 81;
      let maxInches = 3;
      $(this).val(maxFeet.toString());
      $nextInput.val(maxInches.toString());
      $(this).data("prev", $(this).val());
      $nextInput.data("prev", $nextInput.val());
      $("#step-1-warning").text("Maximum dimension is 25 meters (81 feet 3 inches) per side.").show();
    } else {
      $("#step-1-warning").hide();
    }
  } else {
    let truncated = value.replace(/\D/g, "").slice(0, 2); // Enforce 2-digit limit
    $(this).val(truncated);
    $(this).data("prev", truncated);
    if (truncated.length === 2) {
      $nextInput.focus();
    }
    // Recalculate total inches after truncation
    let totalInches = parseInt(truncated) * 12 + parseInt($nextInput.val() || 0);
    let convertedValue = totalInches * t_scale;
    let maxTotalInches = 984; // 81 feet 3 inches ≈ 24.77 meters

    if (convertedValue > 25) { // Cap at 25 meters after digit check
      let maxFeet = 81;
      let maxInches = 3;
      $(this).val(maxFeet.toString());
      $nextInput.val(maxInches.toString());
      $(this).data("prev", $(this).val());
      $nextInput.data("prev", $nextInput.val());
      $("#step-1-warning").text("Maximum dimension is 25 meters (81 feet 3 inches) per side.").show();
    } else {
      $("#step-1-warning").hide();
    }
  }
});

function init() {
  console.log('Initializing quote calculator...');
  
  // Load variant map from global window object
  if (typeof window.variantMap !== 'undefined') {
    variant_map = window.variantMap;
    console.log('Loaded variant_map on init:', variant_map);
  } else {
    console.warn('variantMap not found in window object during init');
  }
  
  refreshData();

  setSelectedUnit(1);
  selectType(1);

  $("#inner").empty();
  addManualCut();
  $("#quote-calculator").show();
  $("#calculator-mode").hide();
  selectMode(0);
  
  console.log('Quote calculator initialization complete');
}

setWideList();

setCollectionLabel();
// Initialize
init();

function formatNumber(n) {
  n = Number(n);
  return n % 1 === 0 ? n.toFixed(0) : n.toFixed(2);
}

// Helper function to format decimal input with smart trailing zero removal
function formatDecimalInput(value, maxBeforeDecimal = 2, maxAfterDecimal = 2) {
  // Handle the case where user just types a decimal point
  if (value === ".") {
    return "0.";
  }
  
  // Handle the case where value starts with decimal point
  if (value.startsWith(".")) {
    let afterDecimal = value.substring(1).replace(/\D/g, "").slice(0, maxAfterDecimal);
    // Remove trailing zeros from afterDecimal
    if (afterDecimal && afterDecimal.endsWith('0')) {
      afterDecimal = afterDecimal.replace(/0+$/, '');
    }
    return "0." + afterDecimal;
  }
  
  let parts = value.split(".");
  let beforeDecimal = parts[0].replace(/\D/g, "").slice(0, maxBeforeDecimal);
  let afterDecimal = parts[1] ? parts[1].replace(/\D/g, "").slice(0, maxAfterDecimal) : "";
  
  // Determine if a decimal point was explicitly typed
  const hasDecimalPoint = value.includes('.');
  
  // Remove trailing zeros from afterDecimal
  if (afterDecimal && afterDecimal.endsWith('0')) {
    afterDecimal = afterDecimal.replace(/0+$/, '');
  }
  
  // Reconstruct the number
  let result = beforeDecimal;
  if (hasDecimalPoint) {
    result += ".";
  }
  result += afterDecimal;
  
  // If the original value ended with a decimal point, ensure it's preserved
  if (value.endsWith('.') && !result.endsWith('.')) {
    result += '.';
  }
  
  return result;
}

document.addEventListener('DOMContentLoaded', function() {
  if (typeof product_json !== 'undefined') {
    // Accessories (clips) setup
    clip_id_list = [];
    clip_title_list = [];
    clip_unit_list = [];
    clip_price_list = [];
    clip_flag = [];
    for (let i = 0; i < 10; i++) {
      const prod = product_json.recommend_products[`product_${i}`];
      if (prod) {
        clip_id_list.push(prod.id);
        clip_title_list.push(prod.title);
        clip_unit_list.push(prod.unit);
        clip_price_list.push(prod.price);
        clip_flag.push(prod.accessories_required ? 1 : 0);
      }
    }
    clip_cnt_list = Array(clip_id_list.length).fill(0);

    // Wide list setup from product_json.variants
    wide_list = [];
    if (Array.isArray(product_json.variants)) {
      product_json.variants.forEach(variant => {
        // Assume option1 is width in meters (customize if needed)
        let width = parseFloat(variant.option1);
        if (!isNaN(width) && !wide_list.includes(width)) {
          wide_list.push(width);
        }
      });
      wide_list.sort((a, b) => b - a);
    }
  }
});
